import React, {useEffect, useState, useRef} from 'react'
import {AUDIENCE} from '../../../utils/constants'
import {
  Alert,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material'
import {Edit, ErrorOutline} from '@mui/icons-material'
import {pink} from '@mui/material/colors'
import {participantsApi, surveysApi} from '../../../services'
import WbSwitch from '../../../components/common/WbSwitch'
import WbButton from '../../../components/common/WbButton'
import CustomisedInvitations from './CustomisedInvitations'
import DOMPurify from 'dompurify'
import useCustomerData from '../../../hooks/useCustomerData'

export default function Invite({survey, tab, setSurvey}) {
  const customer = useCustomerData()
  const [email, setEmail] = useState(false)
  const [portal, setPortal] = useState(false)
  const [sms, setSms] = useState(false)
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [qr, setQr] = useState(false)
  const [emoji, setEmoji] = useState(false)
  const [missingEmailCount, setMissingEmailCount] = useState(0)
  const isFirstRender = useRef(true)

  //const [hasEmails, setHasEmails] = useState(true)
  //const [editSubject, setEditSubject] = useState(false)
  //const [editMessage, setEditMessage] = useState(false)

  useEffect(() => {
    if (survey) {
      let n = null
      if (tab === AUDIENCE.STAFF) {
        n = JSON.parse(survey?.staffNotification)
        //setHasEmails(true)
      }
      if (tab === AUDIENCE.PARENT) {
        n = JSON.parse(survey?.parentNotification)
        //setHasEmails(true)
      }
      if (tab === AUDIENCE.STUDENT) {
        n = JSON.parse(survey?.pupilNotification)
        //n.Email = true //ToDo need to remove this line
        participantsApi
          .haveAllStudentEmails(survey.schoolId, survey.matId)
          .then(e => {
            setMissingEmailCount(e)
            //setEmail(e > 0 ? false : true)
          })
      }
      if (n) {
        setEmail(n.Email)
        setSms(n.Sms)
        setPortal(n.Portal)
        setSubject(n.Subject)
        setMessage(n.Message)
        setQr(n.Qr ? n.Qr : false)
        setEmoji(n.Emoji ? n.Emoji : false)
      }
    }
  }, [tab])
  useEffect(() => {
    
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if (survey) {
      let n = {
        Email: email,
        Sms: sms,
        Portal: portal,
        Qr: qr,
        Emoji: emoji,
        Subject: subject,
        Message: message,
      }
      let newSurvey = {...survey}
      if (tab === AUDIENCE.STAFF) {
        newSurvey = {...survey, staffNotification: JSON.stringify(n)}
      }
      if (tab === AUDIENCE.PARENT) {
        newSurvey = {...survey, parentNotification: JSON.stringify(n)}
      }
      if (tab === AUDIENCE.STUDENT) {
        newSurvey = {...survey, pupilNotification: JSON.stringify(n)}
      }
      setSurvey(newSurvey)
      surveysApi.put(newSurvey).then(e => {})
    }
  }, [email, sms, portal, subject, message, qr, emoji])

  const utiliseTemplate = template => {
    setSubject(template.subject)
    setMessage(template.message)
  }

  const getTooltip = codeType => {
    var cascader = 'Emoji'
    var cascader1 = 'by entering their unique emoji code'
    if (codeType === 'qr') {
      cascader = 'QR'
      cascader1 = 'by scanning their personalised QR code'
    }
    return (
      <Tooltip
        title={`Students can answer the survey ${cascader1} which you can print out from your data management settings. The same ${cascader} code will be valid for any survey assigned to the student in the future`}
      >
        <ErrorOutline></ErrorOutline>
      </Tooltip>
    )
  }

  return (
    <Grid container>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <>
          <FormControlLabel
            control={
              <WbSwitch
                checked={email}
                onChange={e => setEmail(!email)}
              ></WbSwitch>
            }
            label="Notify by Email"
          ></FormControlLabel>
          {missingEmailCount > 0 ? (
            <Tooltip
              title={`${missingEmailCount}  student(s)s do not have email addresses synced from your MIS. 
              If you choose email delivery with no other delivery options these students will not receive an invitation.`}
            >
              <ErrorOutline sx={{color: pink[500]}}></ErrorOutline>
            </Tooltip>
          ) : (
            ''
          )}
        </>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        {tab === AUDIENCE.STUDENT ? (
          <>
            <FormControlLabel
              control={
                <WbSwitch checked={qr} onChange={e => setQr(!qr)}></WbSwitch>
              }
              label="Login using QR code"
            ></FormControlLabel>
            {getTooltip('qr')}
          </>
        ) : null}
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        {tab === AUDIENCE.STUDENT ? (
          <>
            <FormControlLabel
              label="Login using Emoji code"
              control={
                <WbSwitch
                  checked={emoji}
                  onChange={e => setEmoji(!emoji)}
                ></WbSwitch>
              }
            ></FormControlLabel>
            {getTooltip('emoji')}
          </>
        ) : null}
      </Grid>

      <Grid item lg={12} md={12} sm={12} xs={12} mt={4} mb={4}>
        <Alert severity="info">
          The email invitation below will be sent to participants unless you
          choose to customise it. You can customise templates for each audience.
        </Alert>
      </Grid>
      <Grid item lg={6} md={12} sm={12} xs={12}>
        Email Subject: {subject}
      </Grid>
      <Grid item lg={6} md={12} sm={12} xs={12} style={{textAlign: 'right'}}>
        <CustomisedInvitations
          utiliseTemplate={utiliseTemplate}
          audience={tab}
          survey={survey}
          setSurvey={setSurvey}
        />
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(message),
          }}
        ></div>
      </Grid>
    </Grid>
  )
}
